// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__BXdcd","content":"GlobalSearch_content__1DDyD"};